import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=dec86aa8&scoped=true&"
import script from "./Change.vue?vue&type=script&lang=js&"
export * from "./Change.vue?vue&type=script&lang=js&"
import style0 from "./Change.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Change.vue?vue&type=style&index=1&id=dec86aa8&lang=scss&scoped=true&"
import style2 from "./Change.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec86aa8",
  null
  
)

export default component.exports